import AssignPercentagesError from './AssignPercentagesError';
class InvalidTotalPercentage extends AssignPercentagesError {
    constructor(options) {
        super('The total allocation percentage must equal 100 percentage', options);
    }
}
export default InvalidTotalPercentage;
